import React from 'react';
import { Link } from 'react-router';
import { Element } from 'react-scroll';
import designersImage from './assets/designers.png';
import mobileDesignersImage from './assets/mobile_designers.png';
import styles from './styles.scss';

function Designers ({
  title,
  description
}) {
  return (
    <div>
      <Element name="designers" />
      <div className="row">
        <div className="col-md-8 col-md-offset-2">
          <div className="text-center">
            <h1>
              Our Rockstar designers.
            </h1>
            <p className={`alt-text ls1 ${styles.networkHeading}`}>
              Our designers are startup-hungry individuals with years of
              experience making it happen for founders.
            </p>
          </div>
        </div>
      </div>
      <DesignersImage />
      <div className="row">
        <div className="col-md-12 text-center">
          <Link className={`btn btn-dc-blue btn-xs-block ${styles.designersButton}`} to="/talent">SEE THEIR WORK</Link>
        </div>
      </div>
    </div>
  );
}

function DesignersImage () {
  return (
    <div className="row">
      <div className="col-md-12">
        <img src={designersImage} className={`${styles.designersImage} hidden-xs visible-sm-block visible-md-block visible-lg-block`} alt="designer network" />
        <img src={mobileDesignersImage} className={`${styles.designersImage} hidden-sm visible-xs-block`} alt="designer network" />
      </div>
    </div>
  );
}

export default Designers;
export { DesignersImage };



// WEBPACK FOOTER //
// ./src/components/Designers/index.js